// Default to the production layout where the React app and the PHP API
// share the same origin (e.g. dialtutors.in/ + dialtutors.in/api).
// For local XAMPP dev where the app is served from /Dail_Tutors/, set
// REACT_APP_API_BASE=/Dail_Tutors/api in frontend/.env.development.local.
const BASE = process.env.REACT_APP_API_BASE || '/api';

async function request(path, { method = 'GET', body } = {}) {
  const res = await fetch(BASE + path, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  let payload = null;
  try { payload = await res.json(); } catch { /* non-json */ }

  if (!res.ok || (payload && payload.ok === false)) {
    const err = new Error((payload && payload.error) || `HTTP ${res.status}`);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  return payload ? payload.data : null;
}

export const api = {
  get:  (p)       => request(p),
  post: (p, body) => request(p, { method: 'POST', body }),
  put:  (p, body) => request(p, { method: 'PUT', body }),
  del:  (p)       => request(p, { method: 'DELETE' }),
};
